{
  "title": "Shift closes",
  "columns": {
    "number": "Number",
    "businessDate": "Business date",
    "branch": "Branch",
    "employee": "Employee",
    "closeTime": "Close time",
    "notes": "Notes"
  },
  "empty": {
    "noResults": "No results",
    "noData": "No data available"
  }
}
